module.exports = __webpack_public_path__ + "img/check.82c1a8fe.svg";